import React from 'react';
import { Row, Col } from 'react-bootstrap';
import CheckAllButton from '../common/Buttons/CheckAllButton.jsx';
import DeleteConfirmButton from '../common/Buttons/DeleteConfirmButton.jsx';

const CartButtons = (props) => {
  return <Row className='mb-3'>
    <Col xs={12} sm={4}>
      <CheckAllButton checked={ props.count === props.checkedCount }
                      disabled={ !props.count }
                      onCheckAllClick={ props.onCheckAllClick }/>
    </Col>
    <Col xs={12} sm={8} className='text-md-right mt-2 mt-sm-0'>
      <DeleteConfirmButton onDeleteClick={ props.onDeleteCheckedClick }
                           title={ gettext('Удалить выбранное') }
                           disabled={ !props.count || !props.checkedCount }
                           checkedCount={ props.checkedCount }/>
    </Col>
  </Row>;
};

export default CartButtons;